const rankingItems = [
  {
    rank: 1,
    title: '星际征途3：银河边境',
    type: '科幻 / 动作',
    hot: '987万 次播放',
    tag: '4K蓝光',
    trend: 'up',
  },
  {
    rank: 2,
    title: '长安十二时辰 第二季',
    type: '古装 / 悬疑',
    hot: '856万 次播放',
    tag: '超清全集',
    trend: 'up',
  },
  {
    rank: 3,
    title: '爆笑综艺：欢乐喜剧人2026',
    type: '综艺 / 喜剧',
    hot: '723万 次播放',
    tag: '高清综艺',
    trend: 'hot',
  },
  {
    rank: 4,
    title: '深海迷踪：蓝光纪录片',
    type: '纪录片 / 自然',
    hot: '651万 次播放',
    tag: '蓝光画质',
    trend: 'up',
  },
  {
    rank: 5,
    title: '韩剧《命运之轮》热播中',
    type: '韩剧 / 爱情',
    hot: '598万 次播放',
    tag: '同步更新',
    trend: 'new',
  },
];

export default function Ranking() {
  return (
    <section id="ranking" className="py-12 md:py-16 bg-background-50">
      <div className="section-container">
        <h2 className="font-display text-2xl md:text-3xl text-foreground-950 text-center mb-2">热播榜单</h2>
        <p className="text-sm text-foreground-500 text-center mb-8 md:mb-10">本周最受欢迎的高清影视内容排名</p>

        <div className="max-w-3xl mx-auto">
          {rankingItems.map((item, i) => (
            <div
              key={i}
              className="flex items-center gap-3 md:gap-4 py-3 md:py-4 border-b border-background-200 last:border-b-0 group hover:bg-background-100/50 transition-colors rounded-md px-3 -mx-3"
            >
              <div className={`w-8 h-8 md:w-10 md:h-10 rounded-lg flex items-center justify-center flex-shrink-0 font-bold text-sm md:text-base ${
                item.rank === 1
                  ? 'bg-primary-500 text-white'
                  : item.rank === 2
                  ? 'bg-primary-400 text-white'
                  : item.rank === 3
                  ? 'bg-accent-500 text-white'
                  : 'bg-background-200 text-foreground-600'
              }`}>
                {item.rank}
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-0.5">
                  <h3 className="text-sm md:text-base font-semibold text-foreground-900 truncate">{item.title}</h3>
                  {item.trend === 'new' && (
                    <span className="inline-flex items-center px-1.5 py-0.5 rounded text-[10px] font-medium bg-accent-100 text-accent-700 whitespace-nowrap">NEW</span>
                  )}
                  {item.trend === 'hot' && (
                    <span className="inline-flex items-center px-1.5 py-0.5 rounded text-[10px] font-medium bg-primary-100 text-primary-700 whitespace-nowrap">
                      <i className="ri-fire-line text-[10px] mr-0.5"></i>HOT
                    </span>
                  )}
                </div>
                <div className="flex items-center gap-2 text-xs text-foreground-500 flex-wrap">
                  <span>{item.type}</span>
                  <span className="w-1 h-1 rounded-full bg-foreground-400"></span>
                  <span>{item.hot}</span>
                  <span className="w-1 h-1 rounded-full bg-foreground-400"></span>
                  <span className="text-primary-600 font-medium">{item.tag}</span>
                </div>
              </div>

              <div className="hidden sm:flex items-center gap-1 text-accent-500">
                <i className="ri-play-circle-line text-lg"></i>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}